import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApplicationService } from 'eas-core-lib';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { ProfileSearchData, ProfileSearchRequest, ProfileSearchResponse } from 'src/app/models/profile-search.model';
import { DatePipe } from '@angular/common';
import { TableSortDirective } from '../../../modules/shared/components/table-sort.directive';
import { PaginatorModule } from 'eas-ui-lib/paginator';
import { ChangeProfileApprovalService } from 'src/app/services/change-profile-approval.service';
import { ChangeRequestSearchDataResponse } from 'src/app/models/change-profile-approval.model';
import { ChangeProfileSearchData } from 'src/app/models/change-profile-search.model';

@Component({
    selector: 'app-change-profile-approval-search',
    templateUrl: './change-profile-approval-search.component.html',
    styleUrls: ['./change-profile-approval-search.component.css'],
    imports: [NgxSpinnerModule, ReactiveFormsModule, FormsModule, TableSortDirective, PaginatorModule, DatePipe]
})
export class ChangeProfileApprovalSearchComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private changeProfileApprovalService = inject(ChangeProfileApprovalService);
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router);
  private appService = inject(ApplicationService);

  showSecurity = true;
  sortData = {
    sortColumn: '',
    sortOrder: ''
  }
  searchForm: FormGroup;
  data: any[] = [];
  filteredData: any[] = [];
  currentPage: number = 1;
  pageSize: number = 10;
  totalSize: number = 0;
  currentPageData: any[] = [];
  globalFilter = '';
  // totalCount = 0;
  requestStatusData = [
    {
      requestAccountStatusKey: 237030,
      accountRequestStatusDesc: 'Approved',
    },
    {
      requestAccountStatusKey: 237010,
      accountRequestStatusDesc: 'Created',
    },
    {
      requestAccountStatusKey: 237050,
      accountRequestStatusDesc: 'On Hold',
    },
    {
      requestAccountStatusKey: 237060,
      accountRequestStatusDesc: 'Rejected',
    },
    {
      requestAccountStatusKey: 237070,
      accountRequestStatusDesc: 'Returned to User',
    },
    // {
    //   requestAccountStatusKey: 237020,
    //   accountRequestStatusDesc: 'Submitted',
    // },
    {
      requestAccountStatusKey: 237040,
      accountRequestStatusDesc: 'Waiting for approval',
    },
  ]

  constructor() {
    this.searchForm = this.formBuilder.group({
      firstName: new FormControl(),
      oaksident: new FormControl(),
      uuid: new FormControl(),
      lastName: new FormControl(),
      requestAccountStatusKey: new FormControl(),
      beginTs: new FormControl(),
      endTs: new FormControl(),
      manualApprovalRequest: new FormControl()
    })
  }

  ngOnInit(): void {
    this.changeProfileApprovalService.showToolBar(false);
    // This hides document tab whenever the user goes to the search even with
    // a browser back button- kevin.low 05/08/24
    this.changeProfileApprovalService.setDocInfo(null);
    // This hides workflow history tab whenever the user goes to the search 
    // even with a browser back button - kevin.low 05/08/24
    this.changeProfileApprovalService.setWorkflowHistoryInfo(null);
    if(this.changeProfileApprovalService.profileSearchCache.payload){
      this.searchForm.patchValue(this.changeProfileApprovalService.profileSearchCache.payload);
      this.sortData = this.changeProfileApprovalService.profileSearchCache.sortData;
      this.currentPage = this.changeProfileApprovalService.profileSearchCache.currentPage;
      this.onDataLoad(this.changeProfileApprovalService.profileSearchCache.searchData);
    }
    // this.appService.claimsGenerated.subscribe(x => {
    //   this.changeProfileApprovalService.hasAccessToSensitiveData().subscribe(hasAccess => {
    //     this.showSecurity = hasAccess;
    //   })
    // })
  }

  onDataLoad(data: ChangeRequestSearchDataResponse){
    this.data = this.filteredData = data?.infoChangeRequestSearchData?.map((res: any) => {
      res.name = ''
      if(res.currentFirstName){
        res.name = res.currentFirstName + ' ';
      } 
      if(res.currentLastName){
        res.name += res.currentLastName
      }
      res.requestAccountStatusDesc = this.getRequestStatusDataDescByKey(res.workflowStateKey);
      res.updateTs = this.getFormattedDate(res.updateTs);
      res.createTs = this.getFormattedDate(res.createTs);
      return res;
    }) || [];
    this.totalSize = data?.totalCount || 0;
    this.currentPageData = this.data.slice();
  }

  getFormattedDate(date: string){
    if(!date  || !date.trim()){
      return null;
    }
    let dt = new Date(date) ;
    if(dt instanceof Date) {
      return dt.toLocaleDateString();
    }
    return null;
  }

  resetForm() {
    this.searchForm.reset();
    this.data = this.filteredData = this.currentPageData = [];
    this.currentPage = 1;
    this.totalSize = 0;
    this.globalFilter = '';
    this.changeProfileApprovalService.clearProfileSearchCache();
  }

  filterTable(event: any) {
    const value = event.target.value;
    if (value) {
      this.filteredData = this.data.filter(data => Object.values(data).some(propVal => propVal && propVal.toString().toUpperCase().includes(value.toUpperCase())));
    } else {
      this.filteredData = this.data;
    }
    this.totalSize = this.filteredData.length;
    this.currentPageData = this.filteredData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    this.currentPage = 1;
  }

  getRequestStatusDataDescByKey(key: number){
    return this.requestStatusData.find(data => data.requestAccountStatusKey == key)?.accountRequestStatusDesc;
  }

  onNameClick(row: ChangeProfileSearchData){
    this.changeProfileApprovalService.setProfileSearchCache(null, null, this.filteredData, this.globalFilter, this.sortData, this.currentPage, this.totalSize);
    this.router.navigateByUrl('profile-management/change/change-profile-approval-details?changeRequestKey='+ row.infoChangeRequestKey);
  }

  // onInputChange(event: any, formControlName){
  //   const inputValue = event.target.value;
  //   const numericValue = inputValue.replace(/[^0-9-]/g,'');
  //   if(inputValue !== numericValue){
  //     event.target.value = numericValue;
  //   }
  //   this.searchForm.get(formControlName).setValue(numericValue);
  // }

  private handleSearch(payload, page: number) {
    this.spinner.show();
    if(payload.requestAccountStatusKey){
      payload.requestAccountStatusKey = +payload.requestAccountStatusKey;
      payload.workflowStateKey = +payload.requestAccountStatusKey
    }
    if(payload.workflowStateKey){
      payload.workflowStateKey = +payload.workflowStateKey;
    }
    if(!payload.beginTs){
      payload.beginTs = null;
    }
    if(!payload.endTs){
      payload.endTs = null;
    }
    if(payload.ssn){
      payload.ssn = payload.ssn.replace('-','');
    }
    this.currentPage = page;
    this.changeProfileApprovalService.getChangeApprovalSearchData(payload, page, this.pageSize, this.sortData.sortColumn, this.sortData.sortOrder).subscribe((data: any) => {
      this.globalFilter = '';
      this.spinner.hide();
      data.infoChangeRequestSearchData = data?.infoChangeRequestSearchData ? data.infoChangeRequestSearchData:[];
      this.onDataLoad(data);
    }, err => {
      this.spinner.hide();
    });
  }

  sortChange(value: {sortColumn: string, sortOrder: 'asc' | 'desc'}){
    this.sortData = value;
    this.handleSearch(this.searchForm.value, 1);
  }

  onSearch(payload) {
    this.handleSearch(payload, 1);
  }

  onPageChanged(page: number) {
    this.currentPage = page;
    this.handleSearch(this.searchForm.value, page);
  }
}
